import React from 'react';
import { Link } from 'react-router-dom';

const DEFAULT_FEATURES = [
  {
    icon: 'user',
    title: 'Adataid sikeresen rögzítve',
    text: 'Köszönjük, hogy megosztottad velünk az adataidat.',
  },
  {
    icon: 'phone',
    title: 'Hamarosan felvesszük veled a kapcsolatot',
    text: 'Munkatársunk rövidesen keresni fog.',
  },
  {
    icon: 'mail',
    title: 'E-mailben is visszaigazolást küldünk',
    text: 'Kérjük, ellenőrizd a beérkező levelek között is.',
  },
];

const DEFAULT_PRIVACY = 'Adataid biztonságban vannak. Harmadik féllel nem osztjuk meg.';

function IconSparkle({ className }) {
  return (
    <svg className={className} width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2l1.2 4.2L17 7.5l-3.8 2.1L12 14l-1.2-4.3L7 7.5l3.8-2.3L12 2zm8 10l.8 2.8L23 15l-2.5 1.4L20 19l-1-3.6-2.5-1.4 2.5-1.4L20 12zM4 14l.8 2.8L8 18l-2.5 1.4L5 23l-1-3.6L1.5 18 4 16.6 4 14z"
      />
    </svg>
  );
}

function IconFeature({ name }) {
  if (name === 'user') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        />
      </svg>
    );
  }
  if (name === 'phone') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
        />
      </svg>
    );
  }
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

function IconPackage() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M21 16.5V8l-9-5-9 5v8.5l9 5 9-5zm-9-12.66L18.18 8 12 11.31 5.82 8 12 3.84zM12 13.09l6.14-3.41v4.45L12 16.95l-6.14-3.41V9.68L12 13.09z"
      />
    </svg>
  );
}

function IconChevron() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  );
}

function IconLock() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      />
    </svg>
  );
}

export default function QuoteRequestSuccess({
  title,
  subtitle,
  banner,
  primary,
  homeTo = '/',
  homeLabel = 'Főoldal',
  features = DEFAULT_FEATURES,
  privacyText = DEFAULT_PRIVACY,
}) {
  return (
    <div className="qf-success">
      <div className="qf-success__decor" aria-hidden="true">
        <span className="qf-success__decor-dots" />
        <span className="qf-success__decor-pin" />
        <span className="qf-success__decor-truck" />
        <span className="qf-success__decor-wave qf-success__decor-wave--1" />
        <span className="qf-success__decor-wave qf-success__decor-wave--2" />
      </div>

      <div className="qf-success__hero">
        <div className="qf-success__icon-wrap">
          <IconSparkle className="qf-success__sparkle qf-success__sparkle--1" />
          <IconSparkle className="qf-success__sparkle qf-success__sparkle--2" />
          <IconSparkle className="qf-success__sparkle qf-success__sparkle--3" />
          <div className="qf-success__check" aria-hidden="true">
            <svg width="28" height="28" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <h1 className="qf-success__title">{title}</h1>
        <p className="qf-success__lead">{subtitle}</p>
        {banner}
      </div>

      <div className="qf-success__features">
        {features.map((f) => (
          <div key={f.title} className="qf-success__feat">
            <div className="qf-success__feat-icon" aria-hidden="true">
              <IconFeature name={f.icon} />
            </div>
            <div className="qf-success__feat-title">{f.title}</div>
            <p className="qf-success__feat-text">{f.text}</p>
          </div>
        ))}
      </div>

      <div className="qf-success__actions">
        {primary ? <div className="qf-success__primary-slot">{primary}</div> : null}
        <Link className="qf-success__btn-secondary" to={homeTo}>
          <span>{homeLabel}</span>
          <IconChevron />
        </Link>
      </div>

      <p className="qf-success__privacy">
        <IconLock />
        <span>{privacyText}</span>
      </p>
    </div>
  );
}

export function QuoteSuccessPrimaryLink({ to, children }) {
  return (
    <Link className="qf-success__btn-primary" to={to}>
      <span className="qf-success__btn-primary-icon" aria-hidden="true">
        <IconPackage />
      </span>
      <span className="qf-success__btn-primary-label">{children}</span>
      <IconChevron />
    </Link>
  );
}

export function QuoteSuccessPrimaryButton({ type = 'button', onClick, children }) {
  return (
    <button type={type} className="qf-success__btn-primary" onClick={onClick}>
      <span className="qf-success__btn-primary-icon" aria-hidden="true">
        <IconPackage />
      </span>
      <span className="qf-success__btn-primary-label">{children}</span>
      <IconChevron />
    </button>
  );
}
